import { Routes } from '@angular/router';
import { DonorAtlasTileComponent } from './donoratlas-addin/donoratlas-addin';

export const routes: Routes = [
    { path: 'donoratlas-addin', component: DonorAtlasTileComponent },
    // Redirect root to the tile
    { path: '', redirectTo: '/donoratlas-addin', pathMatch: 'full' }
];
